var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { CircleIcon } from './circle-icon';
export var MenuCircleIcon = function MenuCircleIcon(props) {
  return React.createElement(CircleIcon, __assign({}, props, {
    viewBox: "0 0 20 20"
  }), React.createElement("path", {
    d: "M15.2178 9.13086H4.7395V10.87H15.2178V9.13086Z"
  }), React.createElement("path", {
    d: "M15.2178 5.65234H4.7395V7.39147H15.2178V5.65234Z"
  }), React.createElement("path", {
    d: "M15.2178 12.6094H4.7395V14.3485H15.2178V12.6094Z"
  }), React.createElement("path", {
    d: "M10 1.73913C14.5652 1.73913 18.2609 5.43478 18.2609 10C18.2609 14.5652 14.5652 18.2609 10 18.2609C5.43478 18.2609 1.73913 14.5652 1.73913 10C1.73913 5.43478 5.43478 1.73913 10 1.73913ZM10 0C4.47826 0 0 4.47826 0 10C0 15.5217 4.47826 20 10 20C15.5217 20 20 15.5217 20 10C20 4.47826 15.5217 0 10 0Z"
  }));
};